import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SpreadPartial from '../spread-partial';

class Component extends BaseComponent {
    render({ positions, view }) {
        if (view) {
            if (view == 'view-1') {
                return (
                    <yes-or-no-spread-view-1>
                        <SpreadPartial
                            positions={positions.slice(0, 4).map((p, i) => ({ ...p, card_index: i }))}
                            view={view}
                        />
                        <SpreadPartial
                            positions={positions.slice(4, 8).map((p, i) => ({ ...p, card_index: i + 4 }))}
                            view={view}
                        />
                    </yes-or-no-spread-view-1>
                );
            }

            return (
                <yes-or-no-spread-view-2>
                    <SpreadPartial
                        positions={positions.map((p, i) => ({ ...p, card_index: i }))} offset='0'
                        view={view}
                    />
                </yes-or-no-spread-view-2>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    positions: state.product && state.product.teeup && state.product.teeup.fields
        && state.product.teeup.fields[2] && state.product.teeup.fields[2].positions,
});

export default connect(mapStateToProps)(Component);
